//const urldata = "https://api.laxmihos.com/api/";
//export const urldata2 = "https://api.laxmihos.com/api/";
const urldata = process.env.REACT_APP_API_URL;
//const urldata = "https://hosindia.com/api/";
export default urldata;
